export default __webpack_public_path__ + "static/media/pic_product_03.3815b9b7.jpg";